import "./header.css";

import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

import { BOOKING_LINK, NAV_LINKS, ROUTES } from "../../data/content";

//Dark see-through bar over the page's hero photo: logo in the middle, menu + Book Your Stay underneath (as on Wix).
//Once the visitor scrolls it turns into a slim solid bar that stays at the top, so the menu is always to hand.
//On phones the menu opens from a button
const Header = () => {
  const [isScrolled, setIsScrolled] = React.useState(false);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const { pathname } = useLocation();
  const toggleRef = React.useRef(null);
  const menuRef = React.useRef(null);

  React.useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  //Close the menu after navigating
  React.useEffect(() => {
    setIsMenuOpen(false);
  }, [pathname]);

  React.useEffect(() => {
    if (!isMenuOpen) {
      return undefined;
    }
    //Stop the page behind scrolling, and move focus into the menu
    document.body.style.overflow = "hidden";
    menuRef.current.querySelector("a").focus();

    const toggle = toggleRef.current;
    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        setIsMenuOpen(false);
        return;
      }
      //Keep Tab inside the menu (and its close button) while it's open
      if (e.key === "Tab") {
        const focusable = [toggle, ...menuRef.current.querySelectorAll("a")];
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
        else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", onKeyDown);
      toggle.focus({ preventScroll: true });
    };
  }, [isMenuOpen]);

  return (
    <header className={`site-header ${isScrolled ? "is-scrolled" : ""} ${isMenuOpen ? "is-menu-open" : ""}`}>
      <div className={"site-header-inner"}>
        <Link
          to={ROUTES.HOME}
          className={"site-logo"}
          aria-label={"Dikalo Highston - home"}
        >
          <img
            src={"/images/logo.png"}
            alt={""}
            width={371}
            height={198}
          />
        </Link>

        <button
          ref={toggleRef}
          type={"button"}
          className={"menu-toggle"}
          aria-expanded={isMenuOpen}
          aria-controls={"site-menu"}
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span className={"menu-toggle-bars"} />
        </button>

        <nav
          ref={menuRef}
          id={"site-menu"}
          className={"site-nav"}
          aria-label={"Main"}
        >
          <ul className={"site-nav-list"}>
            {NAV_LINKS.map((link) => (
              <li key={link.path}>
                <NavLink
                  to={link.path}
                  end
                  className={"site-nav-link"}
                >
                  {link.label}
                </NavLink>
              </li>
            ))}
          </ul>
          <a
            href={BOOKING_LINK}
            className={"site-nav-book"}
            target={"_blank"}
            rel={"noopener noreferrer"}
          >
            Book Your Stay
          </a>
        </nav>
      </div>
      <div
        className={"site-menu-backdrop"}
        onClick={() => setIsMenuOpen(false)}
        aria-hidden={"true"}
      />
    </header>
  );
};

export default Header;
